module.exports = __webpack_public_path__ + "img/iphone_b.ff4473d7.png";